import { render, staticRenderFns } from "./ProductSetOptionAddForm.vue?vue&type=template&id=2d24552e&"
import script from "./ProductSetOptionAddForm.vue?vue&type=script&lang=ts&"
export * from "./ProductSetOptionAddForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports